import { Component, Input, OnInit } from '@angular/core';
import { EventService } from 'src/app/main/content/sections/services/event-service';

interface ContentData {
  url: string;
  img: string;
  text?: string;
}

@Component({
  selector: 'template-control-url-preview-item',
  templateUrl: './template-control-url-preview-item.component.html',
  styleUrls: ['./template-control-url-preview-item.component.scss']
})
export class TemplateControlUrlPreviewItemComponent implements OnInit {
  @Input() content?: ContentData = null;

  constructor(
    private eventService: EventService
  ) { }

  ngOnInit(): void {
  }

  anchorClicked(event: Event) {
    this.eventService.emitEvent("anchorClicked", event);
  }

}
